import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { FaTimes, FaPlus } from "react-icons/fa";
import cn from "classnames";

import { Page } from "ui/components";
import CameraScreen from "./camera";

import { Manifest } from "services/action";
import epod from "ui/assets/epod.png";
import moment from "moment";
import { UTCFormat } from "utilities/common";

const ManifestStart = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state?.Form);
  const Session = useSelector((state) => state?.Auth?.session);

  const [img, setImage] = React.useState([]);
  const [pos, setPos] = React.useState(null);
  const [data, setData] = React.useState(null);

  const [show, setShow] = React.useState(false);

  const $getManifest = async (e) => {
    const req = await Dispatch(Manifest.$get(e));

    if (req?.message === "success") {
      setData(req?.data);
    }
  };

  const $removeImg = async (i) => {
    let newImg = [...img];
    newImg.splice(i, 1);
    setImage(newImg);
  };

  const $onStart = async (e) => {
    let payload = {
      actor_name: Session?.name,
      actor_phone: Session?.phone,
      images: img,
      atd_at: UTCFormat(
        moment().format("YYYY-MM-DD"),
        moment().format("HH:mm")
      ),
      latitude: pos?.lat,
      longitude: pos?.lng,
    };

    if (data?.status === "published") {
      const req = await Dispatch(Manifest.$accept(data?.id, payload));
      if (req?.message === "success") {
        const req = await Dispatch(Manifest.$start(data?.id, payload));
        if (req?.message === "success") {
          History.goBack();
        }
      }
    } else if (data?.status === "accepted") {
      const req = await Dispatch(Manifest.$start(data?.id, payload));

      if (req?.message === "success") {
        History.goBack();
      }
    }
  };

  React.useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setPos({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (error) => {
        // See error code charts below.
        console.log(error.code, error.message);
      },
      { enableHighAccuracy: true, timeout: 60000, maximumAge: Infinity }
    );
  }, []);

  React.useEffect(() => {
    $getManifest(match?.params?.id);
  }, []);

  // React.useEffect(() => {
  //   if (!img || img?.length === 0) {
  //     setShow(true);
  //   }
  // }, [img]);

  return (
    <Page
      title={<img src={epod} alt="" height={25} />}
      backTo={() => History.goBack()}
      action={
        <div>
          <Button
            type="button"
            variant="success"
            className={cn(
              "pe-4 ps-4 rounded w-100",
              StateForm?.loading ? "btn-loading" : ""
            )}
            onClick={() => $onStart()}
          >
            Simpan
          </Button>
        </div>
      }
    >
      <div className="px-2 py-3">
        <div className="row align-items-center justify-content-center ">
          {img?.map((d, i) => (
            <div
              key={i}
              className="position-relative col-4"
              style={{ height: 100, width: 100, margin: 5 }}
            >
              <div
                className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center bg-danger rounded-circle border border-2 border-white mt-n2 me-n1 rounded"
                style={{ height: 25, width: 25 }}
                onClick={() => $removeImg(i)}
              >
                <FaTimes color="#fff" />
              </div>
              <img
                src={d}
                alt=""
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: 5,
                }}
              />
            </div>
          ))}

          {StateForm?.loading ? (
            <div
              className="col-4 rounded bg-dark bg-opacity-25 d-flex flex-column align-items-center justify-content-center"
              style={{ height: 100, width: 80, margin: 5 }}
            >
              <div className="spinner-border text-blue" role="status"></div>
              <div>
                <small>uploading</small>
              </div>
            </div>
          ) : null}

          <div
            className="col-4 d-flex flex-column align-items-center justify-content-center"
            onClick={() => setShow(true)}
          >
            <div
              className={cn(
                "border-dashed rounded  d-flex flex-column align-items-center justify-content-center",
                StateForm?.errors?.images ? "border-danger" : "border-primary"
              )}
              style={{ height: 100, width: 80, margin: 5 }}
            >
              <FaPlus
                size={20}
                color={StateForm?.errors?.images ? "red" : "#2f83ba"}
              />
              <div>
                <small>ambil foto</small>
              </div>
            </div>

            {StateForm?.errors?.images ? (
              <div
                className="text-center"
                style={{ marginBottom: 5, marginTop: 10 }}
              >
                <span style={{ color: "red" }}>
                  {StateForm?.errors?.images}
                </span>
              </div>
            ) : null}
          </div>
        </div>

        {StateForm?.errors?.id ? (
          <div
            className="text-center"
            style={{ marginBottom: 5, marginTop: 10 }}
          >
            <span style={{ color: "red" }}>{StateForm?.errors?.id}</span>
          </div>
        ) : null}
      </div>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        centered
        size="small"
        enforceFocus={true}
        fullscreen
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <CameraScreen
            setImg={setImage}
            numberImg={img?.length}
            onClose={() => setShow(false)}
            code={data?.id}
            type="start"
          />
        </Modal.Body>
      </Modal>
    </Page>
  );
};

export default ManifestStart;
